import axiosInstance from "../../../api/axiosConfig";

export const getUserLogs = (params: any) => {
  return axiosInstance.get("/admin/user-logs", {
    params: params,
  });
};
